module.exports = __webpack_public_path__ + "img/dirty-bird.35870a65.png";